var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_Group",
    "data-name": "icon Group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.832,
    height: 47.01,
    viewBox: "0 0 48.832 47.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6466",
    "data-name": "Caminho 6466",
    d: "M26.219,12.07a11.337,11.337,0,0,0-7.395,20.8,1.971,1.971,0,0,1,.872,1.657h0a1.98,1.98,0,0,1-1.657,1.953,33.4,33.4,0,0,0-9.775,3.1,7.674,7.674,0,0,0-4.125,5.3,7.517,7.517,0,0,0,7.369,8.982H38.349a7.517,7.517,0,0,0,7.369-8.982,7.674,7.674,0,0,0-4.125-5.3,33.4,33.4,0,0,0-9.775-3.1,1.98,1.98,0,0,1-1.657-1.953,1.953,1.953,0,0,1,.872-1.648,11.337,11.337,0,0,0-4.822-20.8Z",
    transform: "translate(-3.995 -6.849)",
    fill: "#c5dafb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6467",
    "data-name": "Caminho 6467",
    d: "M47.238,19.965A7.552,7.552,0,1,0,37.925,8.149a1.683,1.683,0,0,0,.174,2.564A14.825,14.825,0,0,1,41.056,31.52,1.195,1.195,0,0,0,41.64,33.4h0a11.8,11.8,0,0,0,3.392.5H52.1A5.014,5.014,0,0,0,57,27.857a5.232,5.232,0,0,0-2.869-3.532,22.4,22.4,0,0,0-6.375-1.988,1.3,1.3,0,0,1-.514-2.372Z",
    transform: "translate(-8.271 -6.094)",
    fill: "#c5dafb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon Group.dbd70bec.svg";
export { ForwardRef as ReactComponent };